import { IKeWebTemplatesApiClient } from "../../../Forms/Types/IKeWebTemplatesApiClient";

import {
    DeleteTemplateRequest,
    ITemplatesApiClient,
    LoadTemplateRequest,
    RestoreTemplateRequest,
    SaveTemplateRequest,
    Templates,
} from "./ITemplatesApiClient";

export class KeWebTemplatesApiClientProxy implements ITemplatesApiClient {
    private readonly templatesApi: IKeWebTemplatesApiClient;

    public constructor(templatesApi: IKeWebTemplatesApiClient) {
        this.templatesApi = templatesApi;
    }

    public async deleteTemplate(params: DeleteTemplateRequest): Promise<void> {
        await this.templatesApi.removeTemplate(params.guid);
    }

    public async getTemplates(): Promise<Templates> {
        return (await this.templatesApi.getTemplates()).map(x => ({ guid: x.id, name: x.name }));
    }

    public async loadTemplate(params: LoadTemplateRequest): Promise<void> {
        await this.templatesApi.loadTemplate(params.guid);
    }

    public async renameTemplate(params: RestoreTemplateRequest): Promise<void> {
        await this.templatesApi.renameTemplate(params.guid, params.templateName);
    }

    public async saveTemplate(params: SaveTemplateRequest): Promise<void> {
        await this.templatesApi.saveAsTemplate(params.templateName, params.guid);
    }
}
